<script setup>
import {reactive,onMounted} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String
});

const data = reactive({
  headers: [
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Message', key: 'message' },
    { title: 'Date/Time', key: 'created_at' },
    { title: 'Created By', key: 'created_by' },
  ],
  loading: false,
  messages: [],
  // timezone: new Date()
})

// const csvExport = (arrData) => {
//   // CSV File
//   let csvContent = 'data:text/csv;charset=utf-8,'
//   csvContent += [
//     Object.keys(arrData[0]).join(';'),
//     ...arrData.map((item) => Object.values(item).join(';')),
//   ]
//     .join('\n')
//     .replace(/(^\[)|(\]$)/gm, '')
//
//   const data = encodeURI(csvContent)
//   const link = document.createElement('a')
//   link.setAttribute('href', data)
//   link.setAttribute('download', 'export.csv')
//   link.click()
// }
// formatTimestampByLocale(timestamp) {
//   const date = new Date(timestamp)
//   return date.toLocaleString()
// },

const formatTimestampByLocale = (timestamp) => {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName: "short"
  }
  return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
}

// getTimezone(timezoneShortened) {
//   const tzName = data.timezone
//   return tzName.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
// },

const listAll = () => {
  data.loading = true
  ApiWrapper.post('messaging', 'list-messages-client', {
        clientId: props.contextIdA
      })
      .then((response) => {
        if(response.messages){
          data.messages = response.messages
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
      })
}

onMounted(()=>{
  listAll()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Client Messages</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon > mdi-file-download </v-icon> <!-- @click="csvExport(csvData)" -->
      </v-toolbar>
      <v-data-table :items="data.messages" :headers="data.headers" :search="data.search" :items-per-page="10" :items-per-page-options="[1, 5, 10]">
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatTimestampByLocale(item.created_at) }}
        </template>
        <!-- <template v-slot:item.created_by="{ item }">
          <entreos-a :href="localPath + '/userprofile/' + item.personid">
            {{ item.created_by }}
          </entreos-a>
        </template> -->
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
[v-cloak] {
  display: none;
}
.container {
  padding: 5px;
}
</style>